import { forwardRef, memo } from 'react';
import SvgIcon, { type SvgIconProps } from '@material-ui/core/SvgIcon';

export const Email = memo(
  forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 248 143"
        data-fill-none
      >
        <g clipPath="url(#clip0_1503_14951)">
          <rect
            width="248"
            height="143"
            rx="8"
            fill="#ECF2FF"
          />
          <path
            d="M130.023 107.117C130.306 113.844 132.522 120.347 136.405 125.846H109.59C113.47 120.345 115.684 113.843 115.967 107.117H130.023Z"
            fill="#E3E3E3"
          />
          <path
            d="M176.846 93.0703V102.435C176.846 103.677 176.353 104.868 175.475 105.746C174.597 106.624 173.406 107.117 172.164 107.117H73.8359C72.5941 107.117 71.4032 106.624 70.5251 105.746C69.647 104.868 69.1537 103.677 69.1537 102.435V93.0703H176.846Z"
            fill="white"
          />
          <path
            d="M176.846 22.836V93.0704H69.1537V22.836C69.1537 21.5942 69.647 20.4032 70.5251 19.5251C71.4032 18.647 72.5941 18.1537 73.8359 18.1537H172.164C173.406 18.1537 174.597 18.647 175.475 19.5251C176.353 20.4032 176.846 21.5942 176.846 22.836Z"
            fill="#66E1FF"
          />
          <path
            d="M69.1537 22.836V93.0704H89.5919L164.509 18.1537H73.8359C72.5941 18.1537 71.4032 18.647 70.5251 19.5251C69.647 20.4032 69.1537 21.5942 69.1537 22.836Z"
            fill="#C2F3FF"
          />
          <path
            d="M109.599 125.846C113.479 120.345 115.693 113.843 115.977 107.117"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M136.401 125.846C132.521 120.345 130.307 113.843 130.023 107.117"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M101.93 125.846H144.07"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M69.1537 93.0703H176.846"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M172.164 18.1537H73.8359C72.5941 18.1537 71.4032 18.647 70.5251 19.5251C69.647 20.4032 69.1537 21.5942 69.1537 22.836V102.435C69.1537 103.677 69.647 104.868 70.5251 105.746C71.4032 106.624 72.5941 107.117 73.8359 107.117H172.164C173.406 107.117 174.597 106.624 175.475 105.746C176.353 104.868 176.846 103.677 176.846 102.435V22.836C176.846 21.5942 176.353 20.4032 175.475 19.5251C174.597 18.647 173.406 18.1537 172.164 18.1537Z"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M106.513 47.0787V58.7385L97.9084 52.9947L106.513 47.0787Z"
            fill="#66E1FF"
          />
          <path
            d="M147.387 52.9947L138.782 58.7385V47.5632L147.387 52.9947Z"
            fill="#66E1FF"
          />
          <path
            d="M147.387 52.9945V75.5826C147.387 76.4384 147.047 77.2592 146.442 77.8644C145.837 78.4695 145.016 78.8095 144.16 78.8095H101.135C100.279 78.8095 99.4586 78.4695 98.8535 77.8644C98.2483 77.2592 97.9084 76.4384 97.9084 75.5826V52.9945L106.513 58.7383L114.624 64.138L115.118 63.7507H130.177L130.672 64.138L138.782 58.7383L147.387 52.9945Z"
            fill="#C2F3FF"
          />
          <path
            d="M141.059 29.3934V57.5971L130.835 64.2448L130.271 63.8028H115.025L114.46 64.2448L104.237 57.5971V29.3934C104.237 28.7422 104.495 28.1177 104.956 27.6572C105.416 27.1967 106.04 26.938 106.691 26.938H138.604C139.255 26.938 139.879 27.1967 140.34 27.6572C140.8 28.1177 141.059 28.7422 141.059 29.3934Z"
            fill="white"
          />
          <path
            d="M134.869 27.4225H106.425C105.844 27.4225 105.288 27.6523 104.877 28.0614C104.467 28.4705 104.237 29.0254 104.237 29.604V57.2438L105.296 57.9462L135.729 27.6014C135.458 27.4838 135.165 27.4229 134.869 27.4225Z"
            fill="white"
          />
          <path
            d="M141.059 49.2252L147.387 52.9947V75.5828C147.387 76.4386 147.047 77.2594 146.442 77.8646C145.837 78.4697 145.016 78.8097 144.16 78.8097H101.135C100.279 78.8097 99.4586 78.4697 98.8535 77.8646C98.2483 77.2594 97.9084 76.4386 97.9084 75.5828V52.9947L103.994 49.2252"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M104.362 72.3558L115.118 63.7509H130.177L140.933 72.3558"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M147.387 52.9945L134.48 61.5995"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M97.9084 52.9945L110.816 61.5995"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M141.059 56.9772V29.6117C141.059 29.0311 140.8 28.4743 140.34 28.0637C139.879 27.6531 139.255 27.4225 138.604 27.4225H106.691C106.04 27.4225 105.416 27.6531 104.956 28.0637C104.495 28.4743 104.237 29.0311 104.237 29.6117V56.9772"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M112.967 35.7847H117.27"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M117.27 42.2384H132.328"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M112.967 48.6921H132.328"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M112.967 55.146H132.328"
            stroke="#191919"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_1503_14951">
            <rect
              width="248"
              height="143"
              rx="8"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
Email.displayName = 'Email';
